import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { SIDEBAR_PADDING } from '../config';
export const SidebarMenuFooterContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  padding: ${SIDEBAR_PADDING};
  flex-shrink: 0;
`;
